module.exports = __webpack_public_path__ + "static/media/shimbashi-soba.8c09ec5e.png";